import { useMutation } from "@tanstack/solid-query";
import { axiosInstance } from "@/api/client";
import type { ContactSalesFormValues } from "../validators/contactSales";

// 1. Mutator function
export const submitContactSales = async (input: ContactSalesFormValues) => {
  await axiosInstance.post("/contact-sales", input);
};

// 2. Custom hook
export const useSubmitContactSales = () => {
  return useMutation(() => ({
    mutationFn: (input: ContactSalesFormValues) => submitContactSales(input),
  }));
};
